/**
 * @legacy Destructured ActionState enum values as named constants.
 *
 * Exists to support consumer apps that import individual constants like:
 *   import { SET_ACTIVE_MENU } from "@forcepoint/platform-coreui"
 *
 * Remove once all apps are migrated to import ActionState enum directly
 * (e.g., import { ActionState } from "@forcepoint/platform-coreui").
 */
import { ActionState } from "../state/core.state"

export { ActionState }

export const {
  GET_APP_CONFIG,
  AUTO_LOGIN,
  APP_LOGOUT,
  SET_APPLICATIONS,
  SET_ACTIVE_APP,
  SET_USER_TOKEN,
  SET_ID_TOKEN,
  GET_COMPANY_ID,
  FETCH_USER_INFO,
  SET_USER_INFO,
  SET_INTER_APP_DATA,
  SET_LOADER_STATUS,
  SET_PAGE_TITLE,
  SET_ACTIVE_MENU,
  SET_SETTINGS_TYPE,
  SET_APP_TITLE,
  GET_PENDING_EULAS,
  SET_PENDING_EULAS,
  SET_FONE_ALERT_CONFIG,
  TOGGLE_AI_PANEL,
  SET_IS_AI_ENABLED,
  SET_AI_PANEL_ALERTS,
  REMOVE_AI_PANEL_ALERT,
  CLEAR_AI_PANEL_ALERTS,
  LOCAL_AUTH_REQUIRED
} = ActionState
